import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Modal } from 'antd';
import '../../../index.scss';
import { customBaseUrl, httpPut } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';

const UpdateCardProduct = ({ showModal, hideModal, getProducts, initialData }) => {
  const [data, setData] = useState(() => {
    if (initialData) {
      return {
        cardFee: initialData.chargeFee || '',
        cardProduct: initialData.productName || '',
        maintenanceFee: initialData.maintenanceFee || '',
        cardProductId: initialData.id || '',
        active: initialData.active ?? true
      };
    }
    return { cardFee: '', cardProduct: '', maintenanceFee: '', cardProductId: '', active: true };
  });

  useEffect(() => {
    if (initialData) {
      setData({
        cardFee: initialData.chargeFee || '',
        cardProduct: initialData.productName || '',
        maintenanceFee: initialData.maintenanceFee || '',
        cardProductId: initialData.id || '',
        active: initialData.active ?? true
      });
    }
  }, [initialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.cardProduct || !data.cardFee) {
      Swal.fire('Warning', 'Card Product name and Card Fee are required', 'warning');
      return;
    }
    showLoader();
    const { cardProductId, cardFee, cardProduct, maintenanceFee, active } = data;
    
    // 1. Update card product base details
    let res = await httpPut(
      `${customBaseUrl.cardUrl}/cms/admin/update-card-product/${cardProductId}?cardProductId=${cardProductId}&cardFee=${cardFee}&cardProduct=${cardProduct}&maintenanceFee=${maintenanceFee}`,
      { cardProductId, cardFee, cardProduct, maintenanceFee, active }
    );

    // 2. Call activation/deactivation endpoint if status changed
    if (initialData && initialData.active !== active) {
      const statusUrl = active
        ? `${customBaseUrl.cardUrl}/cms/admin/activate-card-product/${cardProductId}`
        : `${customBaseUrl.cardUrl}/cms/admin/deactivate-card-product/${cardProductId}`;
      await httpPut(statusUrl);
    }

    const isSuccess = res && (
      res.status === true || 
      res.respCode === 0 || 
      (res.message && (
        res.message.toLowerCase().includes('success') || 
        res.message.toLowerCase().includes('activated') || 
        res.message.toLowerCase().includes('deactivated') ||
        res.message.toLowerCase().includes('updated')
      ))
    );

    if (isSuccess) {
      hideLoader();
      Swal.fire('Done', 'Card product updated successfully', 'success');
      hideModal(false);
      getProducts();
    } else {
      hideLoader();
      Swal.fire('Error', res?.message || 'Failed to update card product', 'error');
    }
  };

  return (
    <Modal
      title={<span style={{ fontSize: '18px', fontWeight: 700, color: '#1C1C1C' }}>Update Card Product</span>}
      centered
      visible={showModal}
      open={showModal}
      onOk={() => hideModal(false)}
      onCancel={() => hideModal(false)}
      width={550}
      footer={null}
      bodyStyle={{ padding: '24px' }}
    >
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054' }} htmlFor='cardFeeInput'>
              Card Fee (NGN)
            </label>
            <input
              type='number'
              style={{
                width: '100%',
                padding: '10px 14px',
                borderRadius: '8px',
                border: '1px solid #D0D5DD',
                fontSize: '14px',
                outline: 'none',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                transition: 'border-color 0.2s'
              }}
              id='cardFeeInput'
              required
              placeholder='1000'
              value={data.cardFee}
              onChange={(e) => setData({ ...data, cardFee: e.target.value })}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054' }} htmlFor='cardProductInput'>
              Card Product
            </label>
            <input
              type='text'
              required
              style={{
                width: '100%',
                padding: '10px 14px',
                borderRadius: '8px',
                border: '1px solid #D0D5DD',
                fontSize: '14px',
                outline: 'none',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                transition: 'border-color 0.2s'
              }}
              id='cardProductInput'
              placeholder='Visa / Verve / Mastercard'
              value={data.cardProduct}
              onChange={(e) => setData({ ...data, cardProduct: e.target.value })}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054' }} htmlFor='maintenanceFeeInput'>
              Maintenance Fee (NGN)
            </label>
            <input
              type='number'
              style={{
                width: '100%',
                padding: '10px 14px',
                borderRadius: '8px',
                border: '1px solid #D0D5DD',
                fontSize: '14px',
                outline: 'none',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                transition: 'border-color 0.2s'
              }}
              id='maintenanceFeeInput'
              placeholder='50'
              value={data.maintenanceFee}
              onChange={(e) => setData({ ...data, maintenanceFee: e.target.value })}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '4px' }}>
            <label style={{ fontWeight: 600, fontSize: '13px', color: '#344054', marginBottom: 0 }} htmlFor='activeSwitchProduct'>
              Active Status
            </label>
            <div className='form-check form-switch mb-0'>
              <input
                className='form-check-input'
                type='checkbox'
                id='activeSwitchProduct'
                style={{ width: '40px', height: '20px', cursor: 'pointer', margin: 0 }}
                checked={data.active}
                onChange={(e) => setData({ ...data, active: e.target.checked })}
              />
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '12px' }}>
            <button
              type='submit'
              style={{
                background: '#FF4B01',
                color: '#fff',
                border: 'none',
                padding: '12px 32px',
                fontSize: '15px',
                fontWeight: 600,
                borderRadius: '8px',
                cursor: 'pointer',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                width: '100%',
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.background = '#E04200'}
              onMouseLeave={(e) => e.target.style.background = '#FF4B01'}
            >
              Update Product
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateCardProduct;
